import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.assign.js";
import _styled from "@emotion/styled/base";
var _excluded = ["children"],
  _excluded2 = ["children", "desktopNoWrap", "shouldRenderDisclaimerAboveCTA"];
function cov_2abro87rr() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/shared.tsx";
  var hash = "e556b87cf0dfde6998efbc207d76eebb5efdca00";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/shared.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 72
        },
        end: {
          line: 41,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 40,
          column: 4
        }
      },
      "2": {
        start: {
          line: 43,
          column: 82
        },
        end: {
          line: 52,
          column: 1
        }
      },
      "3": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 51,
          column: 4
        }
      },
      "4": {
        start: {
          line: 54,
          column: 54
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "5": {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 55,
          column: 41
        }
      },
      "6": {
        start: {
          line: 58,
          column: 47
        },
        end: {
          line: 60,
          column: 1
        }
      },
      "7": {
        start: {
          line: 59,
          column: 2
        },
        end: {
          line: 59,
          column: 64
        }
      },
      "8": {
        start: {
          line: 67,
          column: 40
        },
        end: {
          line: 69,
          column: 1
        }
      },
      "9": {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 68,
          column: 53
        }
      },
      "10": {
        start: {
          line: 72,
          column: 20
        },
        end: {
          line: 75,
          column: 1
        }
      },
      "11": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 93,
          column: 1
        }
      },
      "12": {
        start: {
          line: 80,
          column: 2
        },
        end: {
          line: 92,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 72
          },
          end: {
            line: 8,
            column: 73
          }
        },
        loc: {
          start: {
            line: 8,
            column: 95
          },
          end: {
            line: 41,
            column: 1
          }
        },
        line: 8
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 43,
            column: 82
          },
          end: {
            line: 43,
            column: 83
          }
        },
        loc: {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 52,
            column: 1
          }
        },
        line: 46
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 54,
            column: 54
          },
          end: {
            line: 54,
            column: 55
          }
        },
        loc: {
          start: {
            line: 54,
            column: 65
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 54
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 58,
            column: 47
          },
          end: {
            line: 58,
            column: 48
          }
        },
        loc: {
          start: {
            line: 58,
            column: 58
          },
          end: {
            line: 60,
            column: 1
          }
        },
        line: 58
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 67,
            column: 40
          },
          end: {
            line: 67,
            column: 41
          }
        },
        loc: {
          start: {
            line: 67,
            column: 64
          },
          end: {
            line: 69,
            column: 1
          }
        },
        line: 67
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 79,
            column: 5
          }
        },
        loc: {
          start: {
            line: 79,
            column: 87
          },
          end: {
            line: 93,
            column: 1
          }
        },
        line: 79
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 79,
            column: 17
          },
          end: {
            line: 79,
            column: 38
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 79,
            column: 33
          },
          end: {
            line: 79,
            column: 38
          }
        }],
        line: 79
      },
      "1": {
        loc: {
          start: {
            line: 87,
            column: 23
          },
          end: {
            line: 87,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 87,
            column: 39
          },
          end: {
            line: 87,
            column: 63
          }
        }, {
          start: {
            line: 87,
            column: 66
          },
          end: {
            line: 87,
            column: 75
          }
        }],
        line: 87
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e556b87cf0dfde6998efbc207d76eebb5efdca00"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2abro87rr = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2abro87rr();
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import React from 'react';
import { Box, Link, Text } from '@opendoor/bricks-next';
import { t } from "../../i18n/translationHelper.mjs";
cov_2abro87rr().s[0]++;
export var EmailDisclaimerText = function EmailDisclaimerText(_ref) {
  var analyticsName = _ref.analyticsName;
  cov_2abro87rr().f[0]++;
  cov_2abro87rr().s[1]++;
  return /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    typography: "$bodyXsmall",
    whiteSpace: "normal",
    $largerThanSM: {
      whiteSpace: 'nowrap'
    }
  }, t('byClickingContinue'), "\xA0", /*#__PURE__*/React.createElement(Link, {
    href: "https://www.opendoor.com/terms",
    target: "_blank",
    variant: "primary",
    size: "xsmall",
    analyticsName: "".concat(analyticsName, "-terms"),
    "aria-label": t('termsAriaLabel')
  }, t('termsOfService')), ' ', t('andTranslated'), ' ', /*#__PURE__*/React.createElement(Link, {
    href: "https://www.opendoor.com/privacy",
    target: "_blank",
    variant: "primary",
    size: "xsmall",
    analyticsName: "".concat(analyticsName, "-privacy-policy"),
    "aria-label": t('privacyAriaLabel')
  }, t('privacyPolicy')), ".");
};
cov_2abro87rr().s[2]++;
export var AccountFormHeader = function AccountFormHeader(_ref2) {
  var children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded);
  cov_2abro87rr().f[1]++;
  cov_2abro87rr().s[3]++;
  return /*#__PURE__*/React.createElement(Text, _extends({
    tag: "h1",
    typography: "$headerMedium"
  }, rest, {
    marginBottom: "$10x",
    textAlign: "left"
  }), children);
};
cov_2abro87rr().s[4]++;
export var AccountFormWrapper = function AccountFormWrapper(props) {
  cov_2abro87rr().f[2]++;
  cov_2abro87rr().s[5]++;
  return /*#__PURE__*/React.createElement(Box, _extends({
    width: "100%"
  }, props));
};
cov_2abro87rr().s[6]++;
export var FormWrapper = function FormWrapper(props) {
  cov_2abro87rr().f[3]++;
  cov_2abro87rr().s[7]++;
  return /*#__PURE__*/React.createElement(Box, _extends({
    width: "100%",
    flexDirection: "column"
  }, props));
};
cov_2abro87rr().s[8]++;
export var PHONE_DEFAULT_DISCLAIMER = function PHONE_DEFAULT_DISCLAIMER(actionText) {
  cov_2abro87rr().f[4]++;
  cov_2abro87rr().s[9]++;
  return t('phoneDefaultDisclaimer', {
    actionText: actionText
  });
};

// eslint-disable-next-line no-restricted-syntax
export var Form = (cov_2abro87rr().s[10]++, /*#__PURE__*/_styled("form", process.env.NODE_ENV === "production" ? {
  target: "e1a669rm0"
} : {
  target: "e1a669rm0",
  label: "Form"
})(process.env.NODE_ENV === "production" ? {
  name: "g0ogvo",
  styles: "width:100%;margin-top:28px"
} : {
  name: "g0ogvo",
  styles: "width:100%;margin-top:28px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
}));
cov_2abro87rr().s[11]++;
export var Disclaimer = function Disclaimer(_ref3) {
  var children = _ref3.children,
    _ref3$desktopNoWrap = _ref3.desktopNoWrap,
    desktopNoWrap = _ref3$desktopNoWrap === void 0 ? (cov_2abro87rr().b[0][0]++, false) : _ref3$desktopNoWrap,
    shouldRenderDisclaimerAboveCTA = _ref3.shouldRenderDisclaimerAboveCTA,
    props = _objectWithoutProperties(_ref3, _excluded2);
  cov_2abro87rr().f[5]++;
  cov_2abro87rr().s[12]++;
  return /*#__PURE__*/React.createElement(Box, props, /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    typography: "$bodyXsmall",
    color: "$contentSecondary",
    whiteSpace: "normal",
    $largerThanSM: desktopNoWrap ? (cov_2abro87rr().b[1][0]++, {
      whiteSpace: 'nowrap'
    }) : (cov_2abro87rr().b[1][1]++, undefined)
  }, children));
};
//# sourceMappingURL=shared.mjs.map